
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22.144","viewBox":"0 0 22 22.144"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M2.292 12.136v-1.585a3.454 3.454 0 013.447-3.447h10.523a3.454 3.454 0 013.447 3.447v1.32h-1.852a1.889 1.889 0 00-1.865 2.044 1.955 1.955 0 001.98 1.714h1.742v1.091a3.454 3.454 0 01-3.447 3.447h-5.028"}}),_c('path',{attrs:{"d":"M2.292 11.375V7.187a2.61 2.61 0 011.687-2.448l7.278-2.75a1.742 1.742 0 012.356 1.632v3.483","opacity":".4"}}),_c('path',{attrs:{"d":"M20.678 12.806v1.888a.941.941 0 01-.917.935h-1.8a1.955 1.955 0 01-1.975-1.714 1.841 1.841 0 01.55-1.494 1.827 1.827 0 011.32-.55h1.907a.941.941 0 01.915.935z"}}),_c('path',{attrs:{"d":"M6.417 11h6.417","opacity":".4"}}),_c('path',{attrs:{"d":"M2.75 15.125h4.895a1.064 1.064 0 011.063 1.063v1.174"}}),_c('path',{attrs:{"d":"M3.868 14.007L2.75 15.125l1.118 1.119M8.708 19.966H3.813a1.064 1.064 0 01-1.063-1.064v-1.173"}}),_c('path',{attrs:{"d":"M7.59 21.084l1.118-1.119-1.118-1.118"}})])])
          )
        }
      }
    